import { Component, Inject, OnInit } from '@angular/core';
import {
	DefaultMatterAdjustmentHCRA,
	MatterAdjustmentHCRA,
	MatterAdjustmentSalePrice,
	MatterAdjustmentSalePriceCalculated,
	NetOutHstOptions,
} from '@models/matter';
import { cloneDeep } from 'lodash';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ICON } from '@core/util/icon';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { AdjustmentsDispatch } from '@state/matter/adjustments';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { AdjustmentDefaultDetailsSelectors } from '@state/global/adjustment-details';
import { calculateHCRA } from '@services/adjustments/hcra';

export interface HCRADialogData {
	adjustmentId?: string;
}

@Component({
	selector: 'app-hcra',
	templateUrl: './hcra-dialog.component.html',
	standalone: false,
})
export class HCRADialogComponent implements OnInit {
	public adjustment: MatterAdjustmentHCRA;
	public creditAmount: number;
	public creditItems = [
		{
			label: 'Vendor',
			value: 'vendor',
		},
		{
			label: 'Purchaser',
			value: 'purchaser',
		},
		{
			label: 'No adjustment',
			value: 'none',
		},
	];

	public enrolmentFee: number;
	public hstAmount: number;
	public id: string;
	public netOutHstOptions = NetOutHstOptions;
	readonly ICON = ICON;

	@SelectSnapshot(AdjustmentDefaultDetailsSelectors.adjustmentDetailsHCRA)
	public adjustmentDetails: boolean;

	@ViewSelectSnapshot(AdjustmentsSelector.salePriceAdjustment)
	salePriceAdjustment: MatterAdjustmentSalePrice;

	@ViewSelectSnapshot(AdjustmentsSelector.salePriceAdjustmentCalculated)
	salePriceCalculated: MatterAdjustmentSalePriceCalculated;

	@ViewSelectSnapshot(AdjustmentsSelector.HCRAAdjustment)
	HCRAAdjustment: MatterAdjustmentHCRA;
	@SelectSnapshot(SelectedMatter.matterHST) hst: number;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: HCRADialogData,
		private dialogRef: MatDialogRef<HCRADialogComponent>,
		private adjustmentDispatch: AdjustmentsDispatch,
	) {
		this.id = data.adjustmentId;
	}

	ngOnInit(): void {
		if (this.id) {
			this.adjustment = cloneDeep(this.HCRAAdjustment);
		} else {
			this.adjustment = {
				...cloneDeep(DefaultMatterAdjustmentHCRA),
				details: this.adjustmentDetails,
			};
		}

		this.creditAmount = 0;
		this.changed();
	}

	cancelModal(): void {
		this.dialogRef.close();
	}

	changed(): void {
		[this.creditAmount, this.hstAmount, this.enrolmentFee] = calculateHCRA(
			this.adjustment.credit,
			this.adjustment.applyHst,
			this.hst,
		);
	}

	saveModal(): void {
		this.adjustmentDispatch.Set(this.adjustment);
		this.dialogRef.close();
	}
}
